import React from "react"

import { ProductPosition } from "shared/types/ProductPosition"

import { ProductPositionActionsOverlayView } from "./ProductPositionActionsOverlayView"
import { useProductPositionActionsOverlayViewModel } from "./hooks/useProductPositionActionsOverlayViewModel"

export interface ProductPositionActionsOverlayPayload {
  projectID: string
  productPositionID: ProductPosition
}

interface ProductPositionActionsOverlayProps {
  payload: ProductPositionActionsOverlayPayload
}

export const ProductPositionActionsOverlay = React.memo(
  ({
    payload: { projectID, productPositionID }
  }: ProductPositionActionsOverlayProps) => (
    <ProductPositionActionsOverlayView
      {...useProductPositionActionsOverlayViewModel(
        projectID,
        productPositionID
      )}
    />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PRODUCT_POSITION_ACTIONS_OVERLAY: ProductPositionActionsOverlayPayload
  }
}
